import { useContext } from 'react'
import RedAlert from './RedAlert'
import { GlobalContext } from '../GlobalContext'

type Props = {
    handleLogout: AnyFunction
}

function NoOrganisation({
    handleLogout
}: Props) {

    const  {
        userData
    } = useContext(GlobalContext)



    return <div className={`flex flex-col items-center`}>
        <div className={`max-w-3xl w-full p-5 flex flex-col gap-5 items-center text-center`}>
            <img src={`/icons/tip-icon.png`} alt={''} className={`w-24`} />
            <p className={`text-lg`}> You have been logged in{userData && userData.name && userData.email ? ` as ${userData.name} (${userData.email})` : ''}, but there is no organisation associated with your account. Please contact your account administrator, or <span className={`hover:opacity-80 underline cursor-pointer`} onClick={handleLogout}>log out</span>. </p>
        </div>
    </div>
}
export default NoOrganisation